import { Skeleton } from "components/common";
import { useScrollAndHighlight } from "hooks";
import { useEffect, useRef, useState } from "react";
import styles from "../index.module.less";

const ScriptLeftPanel = (props) => {
  const { explanations = [], skeletonLoading = false } = props;
  const [selectedTab, setSelectedTab] = useState(explanations?.[0]?.title);
  const isProgrammaticScroll = useRef(false); // Flag to prevent scroll event logic

  // Use the custom hook for scrolling and highlighting - pass the styles object
  const { scrollToElement } = useScrollAndHighlight(styles, 20, 1000);

  const handleScroll = () => {
    if (isProgrammaticScroll.current || !explanations?.length) return;

    let bestMatch = null;
    let bestTop = Infinity;
    const offset = 20; // Same offset as the hook

    explanations.forEach((explanation, index) => {
      const element = document.getElementById(explanation?.id);
      if (element) {
        const rect = element.getBoundingClientRect();
        // Account for offset - element is "visible" if it's within the adjusted viewport
        const adjustedTop = rect.top + offset;
        const isVisible = adjustedTop >= 0 && adjustedTop <= window.innerHeight;

        if (isVisible && adjustedTop < bestTop) {
          bestTop = adjustedTop;
          bestMatch = explanation.title;
        }
      }
    });

    if (bestMatch && bestMatch !== selectedTab) {
      setSelectedTab(bestMatch);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, true);
    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [explanations, selectedTab]);

  const renderExplanation = (title, id, index) => {
    return (
      <div
        key={index}
        className={`pointer ${styles.explanationBox} ${
          title === selectedTab ? `${styles.active}` : ""
        }`}
        onClick={() => {
          setSelectedTab(title);
          // Set flag to prevent scroll event interference
          isProgrammaticScroll.current = true;

          // Use the custom hook to scroll and highlight
          scrollToElement(id);

          // Reset flag after a delay to allow scroll to complete
          setTimeout(() => {
            isProgrammaticScroll.current = false;
          }, 1000);
        }}
      >
        {title}
      </div>
    );
  };

  return (
    <div className={styles.leftSection}>
      {skeletonLoading
        ? [1, 2, 3, 4, 5, 6, 7, 8, 9].map((e, i) => (
            <div key={i} className={`pointer ${styles.explanationBox}`}>
              <Skeleton type={"button"} width={"10vw"} />
            </div>
          ))
        : explanations?.length &&
          explanations.map((e, i) => renderExplanation(e?.title, e?.id, i))}
    </div>
  );
};

export default ScriptLeftPanel;
